import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import PropTypes from 'prop-types';

const AAFModalSuccessPTV = (props = {}) => {
  const title = Translator.get('iptv_modal_title_label','Tu operación ha sido exitosa');
  const content = Translator.get('iptv_modal_description_label','Te llegará un email de confirmación al correo electrónico {@EMAIL}. <br> Al dar click en VER AHORA empieza tu periodo de alquiler de 48 horas');
  const p = {
    content,
    title,
    replaces: { '{@EMAIL}': props.email },
    alwaysEnabled: true,
    buttons: [
      {
        content: Translator.get('iptv_modal_option_button_close', 'ACEPTAR'),
        props: {
          onClick: (e) => {props.handleClose(e, props.callback);},
          className: 'aaf-modal-button aaf-modal-button-primary'
        }
      }
    ],
    aafNewStyle: true,
    className: 'aaf-modal',
    asset: Asset.get('mail_modal_icon_confirm'),
  };
  return <ModalWrapper {...p} />;
};

AAFModalSuccessPTV.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string
};

export default withOnClose(AAFModalSuccessPTV);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalSuccessPTV.jsx